/**
 * @Author: Ali2vu <751815097@qq.com>
 * @Date: 2020-06-11 17:14:12
 * @LastEditors: Ali2vu
 * @LastEditTime: 2020-06-12 10:29:05
 */

// import wx from '@/utils/wx'

const storageObj = {
  set: function (key, items) {
    window.localStorage.setItem(key, JSON.stringify(items))
    // wx.setStorage({
    //   key: key,
    //   data: items
    // })
    // uni.setStorageSync(key, items)
  },
  // setSync: function (key, value) {
  //   // uni.setStorageSync(key, value)
  // },
  get: function (key) {
    var val = window.localStorage.getItem(key)
    val = val ? JSON.parse(val) : val
    return val
    // return uni.getStorageSync(key)
    // wx.getStorage({
    //   key: key,
    //   success: res => {
    //     // console.log(res.data)
    //     return res.data
    //   }
    // })
  },
  remove: function (key) {
    window.localStorage.removeItem(key)
  }
}

export default storageObj
